const dashboard = () => import(/* webpackPrefetch: true */ '@/views/private/index.vue')
const profile = () => import(/* webpackPrefetch: true */ '@/views/private/profile/index.vue')

const menu = () => import(/* webpackPrefetch: true */ '@/views/private/menu.vue')
const user = () => import(/* webpackPrefetch: true */ '@/views/private/user/index.vue')
const user_detail = () => import(/* webpackPrefetch: true */ '@/views/private/user/_id.vue')
const user_add = () => import(/* webpackPrefetch: true */ '@/views/private/user/add/index.vue')
const user_edit = () => import(/* webpackPrefetch: true */ '@/views/private/user/edit/_id.vue')


const project = () => import(/* webpackPrefetch: true */ '@/views/private/project/index.vue')
const project_detail = () => import(/* webpackPrefetch: true */ '@/views/private/project/_id.vue')
const project_add = () => import(/* webpackPrefetch: true */ '@/views/private/project/add/index.vue')
const project_edit = () => import(/* webpackPrefetch: true */ '@/views/private/project/edit/_id.vue')


const category_user = () => import(/* webpackPrefetch: true */ '@/views/private/category-user/index.vue')
const category_user_add = () => import(/* webpackPrefetch: true */ '@/views/private/category-user/add/index.vue')
const category_user_edit = () => import(/* webpackPrefetch: true */ '@/views/private/category-user/edit/_id.vue')


const coa = () => import(/* webpackPrefetch: true */ '@/views/private/coa.vue')
const coa_aktiva = () => import(/* webpackPrefetch: true */ '@/views/private/coa/aktiva/index.vue')
const coa_pasiva = () => import(/* webpackPrefetch: true */ '@/views/private/coa/pasiva/index.vue')
const coa_pendapatan = () => import(/* webpackPrefetch: true */ '@/views/private/coa/pendapatan/index.vue')
const coa_biaya = () => import(/* webpackPrefetch: true */ '@/views/private/coa/biaya/index.vue')

const neraca = () => import(/* webpackPrefetch: true */ '@/views/private/neraca/index.vue')

const laba_rugi = () => import(/* webpackPrefetch: true */ '@/views/private/laba-rugi/index.vue')

const jurnal = () => import(/* webpackPrefetch: true */ '@/views/private/jurnal/index.vue')
const jurnal_add = () => import(/* webpackPrefetch: true */ '@/views/private/jurnal/add/index.vue')

const buku_besar = () => import(/* webpackPrefetch: true */ '@/views/private/buku-besar/index.vue')

const set_saldo_awal = () => import(/* webpackPrefetch: true */ '@/views/private/set-saldo-awal/index.vue')

const audit = () => import(/* webpackPrefetch: true */ '@/views/private/audit/index.vue')

const trial_balance = () => import(/* webpackPrefetch: true */ '@/views/private/trial-balance/index.vue')


const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: dashboard,
    meta: {
      title: "Dashboard"
    }
  },

  {
    path: "/profile",
    name: "Profile",
    component: profile,
    meta: {
      title: "Profile"
    }
  },

  {
    path: "/menu",
    name: "Menu",
    component: menu,
    meta: {
      title: "Menu"
    }
  },

  {
    path: "/user",
    name: "User",
    component: user,
    meta: {
      title: "User"
    }
  },

  {
    path: "/user/detail/:id",
    name: "User Detail",
    component: user_detail,
    meta: {
      title: "User Detail"
    }
  },

  {
    path: "/user/add",
    name: "User Add",
    component: user_add,
    meta: {
      title: "User Add"
    }
  },

  {
    path: "/user/edit/:id",
    name: "User Edit",
    component: user_edit,
    meta: {
      title: "User Edit"
    }
  },

  {
    path: "/category-user",
    name: "Category User",
    component: category_user,
    meta: {
      title: "Kategori User"
    }
  },

  {
    path: "/category-user/add",
    name: "Category User Add",
    component: category_user_add,
    meta: {
      title: "Tambah Kategori User"
    }
  },

  {
    path: "/category-user/edit/:id",
    name: "Category User Edit",
    component: category_user_edit,
    meta: {
      title: "Ubah Kategori User"
    }
  },

  {
    path: "/coa",
    name: "CoA",
    component: coa,
    meta: {
      title: "Chart of Account"
    },
    children: [
      {
        path: "/coa/aktiva",
        name: "Chart of Account Aktiva",
        component: coa_aktiva,
        meta: {
          title: "Chart of Account Aktiva",
        }
      },
      {
        path: "/coa/pasiva",
        name: "Chart of Account Pasiva",
        component: coa_pasiva,
        meta: {
          title: "Chart of Account Pasiva",
        }
      },
      {
        path: "/coa/pendapatan",
        name: "Chart of Account Pendapatan",
        component: coa_pendapatan,
        meta: {
          title: "Chart of Account Pendapatan",
        }
      },
      {
        path: "/coa/biaya",
        name: "Chart of Account Biaya",
        component: coa_biaya,
        meta: {
          title: "Chart of Account Biaya",
        }
      },
    ]
  },

  {
    path: "/neraca",
    name: "Neraca",
    component: neraca,
    meta: {
      title: "Neraca"
    }
  },

  {
    path: "/laba-rugi",
    name: "Laba Rugi",
    component: laba_rugi,
    meta: {
      title: "Laba Rugi"
    }
  },

  {
    path: "/jurnal",
    name: "Jurnal",
    component: jurnal,
    meta: {
      title: "Jurnal"
    }
  },

  {
    path: "/jurnal/add",
    name: "Jurnal Add",
    component: jurnal_add,
    meta: {
      title: "Jurnal Add"
    }
  },

  {
    path: "/buku-besar",
    name: "Buku Besar",
    component: buku_besar,
    meta: {
      title: "Buku Besar"
    }
  },

  {
    path: "/set-saldo-awal",
    name: "Set Saldo Awal",
    component: set_saldo_awal,
    meta: {
      title: "Set Saldo Awal"
    }
  },

  {
    path: "/project",
    name: "Project",
    component: project,
    meta: {
      title: "Project"
    }
  },
  
  {
    path: "/project/detail/:id",
    name: "Project Detail",
    component: project_detail,
    meta: {
      title: "Detail Project"
    }
  },
  {
    path: "/project/add",
    name: "Project Add",
    component: project_add,
    meta: {
      title: "Tambah Project"
    }
  },
  {
    path: "/project/edit/:id",
    name: "Project Edit",
    component: project_edit,
    meta: {
      title: "Ubah Project"
    }
  },
  {
    path: "/audit",
    name: "Audit",
    component: audit,
    meta: {
      title: "Audit"
    }
  },
  {
    path: "/trial-balance",
    name: "Trial Balance",
    component: trial_balance,
    meta: {
      title: "Trial Balance"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})